import { type IDropdownItem } from 'shared/ui'
import { type IInboxCombine } from 'entities/Inbox'
import { type ConversationMenuStore } from 'pages/conversations/ui/ConversationMenu/store/conversationMenuStore'

const typeTeamsMute = 'mute'

type IActionTeamsMute = {
  inbox: IInboxCombine
  item: IDropdownItem
}

export const menuTeamsMute = (inbox: IInboxCombine): IDropdownItem => {
  if (inbox.type !== 'inbox') {
    return {
      id: typeTeamsMute,
      label: '',
    }
  }

  return {
    id: typeTeamsMute,
    iconL: inbox.isMuted ? 'bellFilled' : 'bell',
    label: inbox.isMuted ? 'Unmute inbox' : 'Mute inbox',
  }
}

export const actionTeamsMute = async (
  { inbox, item }: IActionTeamsMute,
  store: ConversationMenuStore
) => {
  if (inbox.type !== 'inbox') return
  if (item.id === typeTeamsMute) {
    await store.entities.inboxesStore.handleUpdateTeamsMute(inbox, !inbox.isMuted)
    store.initInboxesTree()
  }
}
